import axios from "axios";
import { baseUrlApiOtodis, xApiKeyOtodis } from "../../config/api/apiConfig";

class TaxOtodisService {
  private axiosOtodisLambda = axios.create({
    baseURL: baseUrlApiOtodis,
  });

  private axiosOtodisGcf = axios.create({
    // baseURL: "http://localhost:9999",
    baseURL: "https://asia-southeast2-autotrimitra.cloudfunctions.net",
  });

  public setToken(token: string) {
    this.axiosOtodisGcf.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public async updateDdmsInvoice(inputData?: any) {
    try {
      return await this.axiosOtodisLambda.put<any>("/order/update/ddms-data", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }

  public async generateCsv(inputData?: any) {
    try {
      return await this.axiosOtodisGcf.put<any>("otodis__taxActivityGCF/tax-out/generate-csv-tax", inputData);
    } catch (error: any) {
      const blob = new Blob([error?.response?.data]);
      const aa = await blob.text();
      const x = JSON.parse(aa);
      throw new Error(x?.message);
    }
  }

  public async uploadInvoiceTaxOut(formData: any) {
    try {
      return await this.axiosOtodisGcf.post("otodis__taxActivityGCF/tax-out/upload-invoice", formData);
    } catch (e: any) {
      throw e.response.data.error.message;
    }
  }

  public async checkUnscannedInvoice() {
    try {
      return await this.axiosOtodisGcf.get("otodis__taxActivityGCF/tax-out/invoice/check-total-unscanned");
    } catch (e: any) {
      throw e.response.data.error.message;
    }
  }

  public async scanInvoice() {
    try {
      return await this.axiosOtodisGcf.get("otodis__taxActivityGCF/tax-out/invoice/scan");
    } catch (e: any) {
      throw e.response.data.error.message;
    }
  }

  public async syncTaxOut(inputData?: any) {
    try {
      return await this.axiosOtodisGcf.put("otodis__taxActivityGCF/tax-out/tax-data-sync", inputData);
    } catch (e: any) {
      throw e.response.data.error.message;
    }
  }

  public async transferMultipleTaxOut(inputData?: any) {
    try {
      return await this.axiosOtodisGcf.post("otodis__taxActivityGCF/transfer/tax-out/multi", inputData);
    } catch (e: any) {
      throw e.response.data.error.message;
    }
  }

  public async transferSingleTaxOut(formData: any) {
    try {
      return await this.axiosOtodisGcf.post("otodis__taxActivityGCF/transfer/tax-out/single", formData);
    } catch (e: any) {
      throw e.response.data.error.message;
    }
  }

  public async TransferMultiTaxIn(inputData?: any, target?: string) {
    try {
      return await this.axiosOtodisGcf.post("otodis__taxActivityGCF/transfer/tax-in/" + target, inputData);
    } catch (e: any) {
      throw e.response.data.error.message;
    }
  }

  public async addTaxManual(inputData?: any) {
    try {
      return await this.axiosOtodisGcf.post("otodis__taxActivityGCF/tax-manual", inputData);
    } catch (e: any) {
      throw e.response.data.error.message;
    }
  }

  public async bridgingGetTaxData(inputData?: any) {
    try {
      return await this.axiosOtodisGcf.post("otodis__taxActivityGCF/misc/bridging/get-tax-data", inputData);
    } catch (e: any) {
      throw e.response.data.error.message;
    }
  }
}

export const taxOtodisService = new TaxOtodisService();
